export default ({ app }) => {
  if (process.client) {
    const DIDOMI_SDK_URL = window.location.origin + '/didomi/didomi.js';

    let didomiLoaded = false;

    // Load Didomi SDK
    const loadDidomiSDK = () => {
      if (didomiLoaded) return;
      didomiLoaded = true;

      // Initialize Didomi's global configuration
      window.didomiConfig = {
        preferences: {
          enableAllButtons: true,
        },
        notice: {
          type: 'optin',
          denyAppliesToLI: true
        },
        theme: {
          buttons: {
            regularButtons: {
              backgroundColor: '#565656',
              textColor: 'white',
              borderWidth: '0px',
              fontSize: '18px',
              textAlign: 'center',
              textTransform: 'uppercase',
            },
            highlightButtons: {
              backgroundColor: '#7db110',
              textColor: 'white',
              borderWidth: '0px',
              fontSize: '18px',
              textAlign: 'center',
              textTransform: 'uppercase',

            }
          }
        }
      };

      // Prepare Didomi's onReady callback
      window.didomiOnReady = window.didomiOnReady || [];
      window.didomiOnReady.push(function (Didomi) {
        console.log('Didomi is loaded');
      });

      // Load Didomi SDK script
      const script = document.createElement('script');
      script.src = DIDOMI_SDK_URL;
      script.async = true;

      script.onload = () => {
        console.log('Didomi SDK script loaded');
      };

      script.onerror = () => {
        console.error('Failed to load Didomi SDK');
      };

      document.head.appendChild(script);
    };

    const loadDidomiWithStrategy = () => {
      const FALLBACK_DELAY = 2000;

      if ('requestIdleCallback' in window) {
        return requestIdleCallback(() => {
          try {
            loadDidomiSDK();
          } catch (error) {
            console.error('Error in loadDidomiSDK:', error);
          }
        });
      }

      const loadWithDelay = () => setTimeout(loadDidomiSDK, FALLBACK_DELAY);

      return document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', loadWithDelay)
        : loadWithDelay();
    };

    loadDidomiWithStrategy();
    
  }
};